<template>
  <v-container class="ma-0 pa-0">
    <hero title="Awards"></hero>
    <v-row class="ma-1">
      <v-col
        v-for="n in 24"
        :key="n"
        :class="{
          custom2cols: $vuetify.breakpoint.xs,
          custom5cols: $vuetify.breakpoint.smAndUp
        }"
      >
        <v-img
          :alt="awards[23-n]"
          :src="`/images/awards/award_${25-n}.png`"
          aspect-ratio="1"
          cover
          class="bg-grey-lighten-2"
        >
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'Awards',
  metaInfo: {
    title: 'Awards',
    meta: [
      { vmid: 'og:title', property: 'og:title', content: 'Awards'},
    ]
  },
   data: () => ({
    awards: [
      '2021 Webby Award, Peoples Choice, False Confessions',
      '2022 Anthem Award, Human & Civil Rights, Best Strategy, Wrongful Conviction',
      '2022 Clio, Impact Award, Jason Flom',
      '2023 Anthem Award, Best Podcast or Audio, Wrongful Conviction',
      '2023 Anthem Award, Best Social Media Campaign, Wrongful Conviction',
      '2023 Signal Awards, Best Public Service & Activism, Wrongful Conviction',
      '2023 Signal Awards, Best Public Service & Activism, Wrongful Conviction with Maggie Freleng',
      '2023 Signal Awards, Listeners Choice, Wrongful Conviction with Maggie Freleng',
      '2023 Ambie Award, Best Documentary, Bone Valley',
      '2023 Ambie Award, Best Reporting, Bone Valley',
      '2023 Signal Award, Limited Series & Specials, Bone Valley',
      '2023 Signal Award, Listeners Choice Award for Individual Episodes, Chapter 9 Bone Valley',
      '2024 Anthem Award, Human & Civil Rights Podcast or Audio, Wrongful Conviction',
      '2024 Anthem Award, Human & Civil Rights, Best Influencer Collaboration, The War On Drugs',
      '2024 iHeart Podcast Award, Social Impact Award, Wrongful Conviction',
      '2024 ADWEEK Award, Best Audience Growth Strategy, The War On Drugs',
      '2024 ADWEEK Award, Podcast Network of the Year, Lava For Good',
      '2024 Signal Award, Activism, Public Service & Social Impact, ERASED: The Murder of Elma Sands',
      '2024 Anthem Award, Human & Civil Rights Podcast, Wrongful Conviction',
      '2025 Webby Award, Individual Episode in Crime & Justice Category, Bone Valley, Halfway Home',
      '2026 Tribeca Festival, Official Selection, Bone Valley Season 5, The Devil\'s Quarry',
    ],
  }),
}
</script>
<style>
.custom2cols {
  width: 50%;
  max-width: 50%;
  flex-basis: 50%;
}
.custom5cols {
  width: 20%;
  max-width: 20%;
  flex-basis: 20%;
}
.custom6cols {
  width: 16%;
  max-width: 16%;
  flex-basis: 16%;
}
</style>
<style lang="sass">
a
  text-decoration: none
.about-text
  font-size: 1.1rem
  color: #dcdcdc
</style>

